// extracted by mini-css-extract-plugin
export default {"button":"Button_button__Y+F0s","default":"Button_default__anHV1","border":"Button_border__LV7ew","link":"Button_link__c2c45","icon":"Button_icon__MbEZx"};